import React from 'react';
import './Style.css';

import { Link } from 'react-router-dom'; // Importing Link for navigation



const Style = ({ style, basePath }) => {

    const { id, image, title } = style;

    return (
        <div className='style-item' key={id}>

            <img src={image} alt={title} /> {/* Product image */}

            {/* Product Title with dynamic path */}
            <Link
                to={{
                pathname: `/${basePath}/${title}`,
                }}
                state={style}>
                <h3>{title}</h3>
            </Link>

        </div>
    );

};

export default Style;